module.exports = __webpack_public_path__ + "static/media/smallGrayTemplate.f25dc5b1.png";